import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Vehicle } from '../vehicle';

@Injectable({
  providedIn: 'root',
})
export class VehicleModelService {
  private api = 'http://localhost:3101/api-core/v1';

  constructor(private http: HttpClient) {
    // do nothing
  }

  getVehicleModels(): Observable<Vehicle[]> {
    return this.http.get<Vehicle[]>(`${this.api}/vehicle-module`);
  }

  createVehicleModel(data: Vehicle): Observable<Vehicle> {
    return this.http.post<Vehicle>(`${this.api}/vehicle-module`, data);
  }

  updateVehicleModel(id: string, data: Vehicle): Observable<Vehicle> {
    return this.http.put<Vehicle>(`${this.api}/vehicle-module/${id}`, data);
  }

  deleteVehicleModel(id: string): Observable<any> {
    return this.http.delete(`${this.api}/vehicle-module/${id}`);
  }

  updateStatus(id: string, status: boolean): Observable<Vehicle> {
    return this.http.patch<Vehicle>(`${this.api}/vehicle-module/status/${id}`, { status });
  }
}
